<script>
  import { FirebaseApp } from "sveltefire";
  import { Router, Route, Link } from "svelte-routing";
  import Route2State from "./Route2State.svelte";

  import Shell from "./Shell.svelte";
  export let url = "";
  import firebase from "firebase/app";
  import "firebase/firestore";
  import "firebase/auth";

  // import "firebase/performance";
  // import "firebase/analytics";
  let firebaseConfig = {
		apiKey: "AIzaSyCOW4rGU4lZM5RxIOhVIhrP-C1rTLisMvE",
		authDomain: "sendgrid-2018.firebaseapp.com",
		databaseURL: "https://sendgrid-2018.firebaseio.com",
		projectId: "sendgrid-2018",
		storageBucket: "sendgrid-2018.appspot.com",
		messagingSenderId: "86056351312",
		appId: "1:86056351312:web:e712de94880244a6fdc355"
	};
  firebase.initializeApp(firebaseConfig);
  const db = firebase.firestore();
  //console.log("@App3.svelte")
</script>

<div class="all">
  <Router url="{url}">
    <FirebaseApp {firebase}>
    <div>
      <Route path="/newsletter/:newsletterId" let:params>
        <!-- <h1>@App3 Newsletter</h1> -->
        <Route2State newsletterIdRoute="{params.newsletterId}"></Route2State>
      </Route>
      <Route path="/list/:listId" let:params>
        <!-- <h1>@App3 List</h1> -->
        <Route2State listIdRoute="{params.listId}"></Route2State>
      </Route>
      <Route path="/section/:sectionId" let:params>
        <!-- <h1>@App3 Section</h1> -->
        <Route2State sectionIdRoute="{params.sectionId}"></Route2State>
      </Route>
      <Route path="/"></Route>
    </div>
    <Shell></Shell>
    </FirebaseApp>
  </Router>
  
</div><!-- /all -->

<!-- Styles -->
<style>
  .all {height: 100%;}
</style>
